import { Outlet } from "react-router-dom";
import Header from "@shared/components/Header";
import { Box } from "@chakra-ui/react";

const MainOutlet = () => {
    return(
        <Box w="100%" h="100vh" bg="gray.100" overflow="auto">
            <Header/>
            <Box as="main" px={4} py={2}>
                <Outlet/>
            </Box>
        </Box>
    )
}

export default MainOutlet;